<portal-instaciti-header [isHome]="false"></portal-instaciti-header>

<portal-instaciti-banner
  [business]="'beauty-and-spa'"
></portal-instaciti-banner>

<div class="container-fluid customGapping desktopSort mb-4">
  <div class="customCard">
    <div class="clearfix">
      <div class="row">
        <div class="col-md-12">
          <nav class="navbar navbar-expand-lg navbar-light cSortNavbar">
            <div class="container-fluid">
              <a class="navbar-brand cSortNav" href="#">SORT BY</a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item active">
                    <a class="nav-link" href="#">NAME</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">RATING</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">PRICE</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="#">DISTANCE</a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid customGapping mobileSort mb-4">
  <div class="customCard">
    <div class="sort-by-wrapper clearfix">
      <div class="row">
        <div class="col-6">
          <div class="sortButton d-grid">
            <button
              class="btn btn-primary btn-block btnFilter"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              SORT
            </button>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="sortList mb-2 p-0">
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">NAME</a>
              </li>
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">RATING</a>
              </li>
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">PRICE</a>
              </li>
              <li class="nav-item">
                <a class="nav-link customColor font16" href="#">DISTANCE</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-6 text-end">
          <div class="filterButton d-grid">
            <button
              class="btn btn-primary btn-block btnFilter"
              data-bs-toggle="collapse"
              href="#collapseExample"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              FILTER
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Listing and Sidebar Sections -->

<div class="container-fluid customGapping">
  <div class="row">
    <!-- Mobile Filter -->
    <div class="mobileFilter mb-4">
      <div class="collapse" id="collapseExample">
        <div class="card card-body">
          <div class="sidebarFilter">
            <h4 class="font20 font500 pb-3">Filter Your Result</h4>
          </div>

          <div class="sidebar-module">
            <div class="popularAreas">
              <h5>POPULAR AREAS</h5>
              <p>
                <a href="#" class="beautyPopularArea"
                  >Beauty Parlours in Delhi</a
                >
              </p>
            </div>

            <h5>RATING RANGE</h5>
            <div class="slider-container mt-3 mb-5">
              <label for="rating">({{ rating.value }})</label>
              <input
                type="range"
                #rating
                (input)="(rating.value)"
                id="rating"
                min="0"
                max="100"
              />
            </div>
            <div *ngFor="let category of headers; let idx = index" class="pt-5">
              <h5>{{ category }}</h5>
              <div class="checkbox-block font-icon-checkbox">
                <input
                  id="-1"
                  name="filter_cuisine"
                  type="checkbox"
                  class="checkbox"
                  checked="checked"
                  (change)="filter($event)"
                />
                <label class="" for="-1">Any</label>
              </div>

              <ng-container
                *ngFor="let data of filterData[idx][category]; let i = index"
              >
                <div *ngIf="i < 4" class="checkbox-block font-icon-checkbox">
                  <input
                    [id]="data.SubCatID"
                    name="filter_cuisine"
                    type="checkbox"
                    class="checkbox"
                    (change)="filter($event)"
                  />
                  <label class="" for="{{ data.SubCatID }}">{{ data.N }}</label>
                </div>
              </ng-container>
              <ng-container *ngIf="filterData[idx][category].length > 4">
                <div class="collapse" id="collapse{{ category }}">
                  <div class="inner">
                    <ng-container
                      *ngFor="
                        let data of filterData[idx][category];
                        let i = index
                      "
                    >
                      <div
                        *ngIf="i >= 4"
                        class="checkbox-block font-icon-checkbox"
                      >
                        <input
                          [id]="data.SubCatID"
                          name="filter_cuisine"
                          type="checkbox"
                          class="checkbox"
                          (change)="filter($event)"
                        />
                        <label class="" for="{{ data.SubCatID }}">{{
                          data.N
                        }}</label>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <button
                  class="btn btn-more-less"
                  data-bs-toggle="collapse"
                  [attr.href]="'#collapse' + category"
                  role="button"
                  aria-expanded="false"
                  aria-controls="collapseExample"
                >
                  Show more
                </button>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile Filter -->

    <div class="col-lg-3 mobileHide">
      <div class="sidebarFilter">
        <h4 class="font20 font500 pb-3">Filter Your Result</h4>
      </div>

      <div class="sidebar-module">
        <h5>RATING RANGE</h5>
        <div class="slider-container mt-3 mb-5">
          <label for="rating">({{ rating.value }})</label>
          <input
            type="range"
            #rating
            (input)="(rating.value)"
            id="rating"
            min="0"
            max="100"
          />
        </div>
        <div *ngFor="let category of headers; let idx = index" class="pt-5">
          <h5>{{ category }}</h5>
          <div class="checkbox-block font-icon-checkbox">
            <input
              id="-1"
              name="filter_cuisine_Any"
              type="checkbox"
              class="checkbox"
              checked="checked"
              (change)="filter($event)"
            />
            <label class="" for="-1">Any</label>
          </div>

          <ng-container
            *ngFor="let data of filterData[idx][category]; let i = index"
          >
            <div *ngIf="i < 4" class="checkbox-block font-icon-checkbox">
              <input
                [id]="data.SubCatID"
                name="filter_cuisine"
                type="checkbox"
                class="checkbox"
                (change)="filter($event)"
              />
              <label class="" for="{{ data.SubCatID }}">{{ data.N }}</label>
            </div>
          </ng-container>
          <ng-container *ngIf="filterData[idx][category].length > 4">
            <div class="collapse" id="collapse{{ category }}">
              <div class="inner">
                <ng-container
                  *ngFor="let data of filterData[idx][category]; let i = index"
                >
                  <div *ngIf="i >= 4" class="checkbox-block font-icon-checkbox">
                    <input
                      [id]="data.SubCatID"
                      name="filter_cuisine"
                      type="checkbox"
                      class="checkbox"
                      (change)="filter($event)"
                    />
                    <label class="" for="{{ data.SubCatID }}">{{
                      data.N
                    }}</label>
                  </div>
                </ng-container>
              </div>
            </div>
            <button
              class="btn btn-more-less"
              data-bs-toggle="collapse"
              [attr.href]="'#collapse' + category"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              Show more
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="col-lg-9">
      <div class="restaurant-list-item-wrapper no-last-bb">
        <div
          *ngFor="let item of listing"
          class="beauty-list-item clearfix border-bottom mb-5 pb-4"
        >
          <div class="GridLex-grid-noGutter-equalHeight row">
            <div class="col-md-3">
              <div class="businessImage">
                <img
                  *ngIf="item.LogoURL"
                  [src]="item.LogoURL"
                  alt="businessImage"
                  class="img-fluid"
                  (error)="item.LogoURL = null"
                />
                <img
                  *ngIf="!item.LogoURL"
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/bizspot/images/not-found.png"
                  alt="businessImage"
                  class="img-fluid"
                />
              </div>
              <div class="instaVerified">
                <img
                  src="https://dkzxkcjlbnjui.cloudfront.net/portal/instaciti-now/instaciti-verified.png"
                  class="img-fluid"
                  alt=""
                />
              </div>
            </div>

            <div class="col-md-9">
              <div class="row">
                <div class="col-md-8 content-wrapper">
                  <h5>
                    <a href="#" class="text-decoration-none beautyColor">{{
                      item.BusinessTitle
                    }}</a>
                  </h5>
                  <p class="businessLocation">
                    <i
                      class="fa fa-map-marker-alt me-2 beautyColor"
                      aria-hidden="true"
                    ></i>
                    {{ item.LocalityName }}
                  </p>
                  <p class="workHourStatement">
                    <i class="far fa-clock me-2 beautyColor"></i>Hours: (All
                    Days), 12:30pm – 10pm
                  </p>
                  <ng-container *ngFor="let attr of item.PopularAttribs">
                    <p *ngIf="attr.ID === 'COSTOF2'" class="pricingStatement">
                      <i class="fas fa-rupee-sign me-2 beautyColor"></i
                      >{{ attr.D }}
                    </p>
                    <p
                      *ngIf="attr.ID === 'CUISINES'"
                      class="cuisineStatement pt-2"
                    >
                      <i class="fas fa-paint-brush me-2 beautyColor"></i
                      ><span *ngFor="let data of attr.D">{{ data }}</span>
                    </p>
                  </ng-container>

                  <p>
                    Best Salon in Paschim Vihar, best makeup Artist in Paschim
                    Vihar, best makeup artist in delhi, Hair Stylist in Paschim
                    vihar, Bridal makeup in Paschim Vihar
                  </p>
                  <!-- <a href="#" class="cViewListingTxt offer">View Full Menu! </a> -->
                  <!-- <br><br> -->
                </div>

                <div class="col-md-4">
                  <div class="rating-wrapper text-end">
                    <div class="rating-item">
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                      <div
                        class="rating-symbol"
                        style="display: inline-block; position: relative"
                      >
                        <i class="fas fa-star"></i>
                      </div>
                    </div>
                    <span class="font12"> (27 reviews)</span>
                  </div>
                  <div class="actionButton pt-2">
                    <!-- <div class="price">Cost for 2: <span>650 - 750Rs.</span> </div> -->
                    <div class="d-grid">
                      <button
                        (click)="
                          openURL(
                            'https://bizcard.instaciti.com/' +
                              item.BusinessHandle
                          )
                        "
                        class="btn viewSignature"
                      >
                        View Signature
                      </button>
                      <button
                        class="btn orderButton mt-3"
                        (click)="openURL(item.HomePageURL)"
                      >
                        Order Now!<i
                          class="fas fa-chevron-circle-right ms-2"
                        ></i></button
                      ><br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<portal-instaciti-footer></portal-instaciti-footer>
